import { useState, useEffect } from "react";
import { loadConnectAndInitialize } from "@stripe/connect-js";
import type { StripeConnectInstance } from "@stripe/connect-js";
import { useAuth0 } from "@auth0/auth0-react";
import { Post } from "../../queries/utils/api";

interface AccountSessionResponse {
  client_secret: string;
}

export const useStripeConnect = (
  connectedAccountId: string | undefined,
  org_id: string
): StripeConnectInstance | undefined => {
  const [stripeConnectInstance, setStripeConnectInstance] = useState<
    StripeConnectInstance | undefined
  >();
  const { getAccessTokenSilently } = useAuth0();

  useEffect(() => {
    if (connectedAccountId) {
      const fetchClientSecret = async (): Promise<string> => {
        try {
          const accessToken = await getAccessTokenSilently();
          const response = await Post<AccountSessionResponse>(
            `/api/stripe/organization/${org_id}/refresh-connect-account`,
            accessToken,
            { account: connectedAccountId }
          );
          return response.client_secret;
        } catch (error) {
          throw new Error(`Failed to fetch account session: ${error}`);
        }
      };

      // console.log("STRIPEKEY", process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY)

      setStripeConnectInstance(
        loadConnectAndInitialize({
          publishableKey: process.env
            .REACT_APP_STRIPE_PUBLISHABLE_KEY as string,
          fetchClientSecret,
          appearance: {
            overlays: "dialog",
            variables: {
              colorPrimary: "#635BFF",
            },
          },
        })
      );
    }
  }, [connectedAccountId, getAccessTokenSilently, org_id]);

  return stripeConnectInstance;
};

export default useStripeConnect;
